module.exports = __webpack_public_path__ + "public/media/developer-header-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/developer-header-icon.png
// module id = ./images/services/developer-header-icon.png
// module chunks = 0